export default __webpack_public_path__ + "static/media/img-b-result-distance-uk_en@2x.9034d8d3.jpg";